// Is the number an australian local mobile number (04 xx...) that can
// be transformed into an international format.
export const isLocalAustralianMobileNumber = (mobileNumber: string) => {
  const trimmed = mobileNumber.replace(/[^\d\+]/g, "");
  return /0[45][\d]{8}/.test(trimmed);
};
